const serviceName = '1xpay';

export const EVENTS = {
  USER: {
    LOGIN: 'user.login',
    LOGIN_SUCCESS: 'user.login_success',
    LOGIN_ERROR: 'user.login_error',
    REGISTER: 'user.register',
    REGISTRING: 'user.registring',
    REGISTER_SUCCESS: 'user.register_success',
    REGISTER_ERROR: 'user.register_error',
    REGISTRATION_STEP_CHANGED: 'user.registration_step_changed',
    PREVIOUS_REGISTRATION_STEP: 'user.previous_registration_step',
    START_REGISTRATION_STEPPER: 'user.start_registration_stepper',
    START_CANCEL_REGISTRATION: 'user.start_cancel_registration',
    CONFIRM_CANCEL_REGISTRATION: 'user.confirm_cancel_registration',
    OTP_GENERATED: 'user.otp_generated',
    LOGOUT: 'user.logout',
    REGISTRATION_COUNTRY: 'user.select_registration_country',
    REGISTRATION_PHONE_COUNTRY: 'user.select_registration_phone_country',
    UPDATE: 'user.update',
    UPDATE_SUCCESS: 'user.update_success',
    UPDATE_ERROR: 'user.update_error',
    REFRESH_DATA: 'user.refresh_data',
    REFRESH_DATA_SUCCESS: 'user.refresh_data_success',
    REFRESH_DATA_ERROR: 'user.refresh_data_error'
  },

  LEGACY_MIGRATION: {
    DETECTED: 'legacy_migration.detected',
    START_MIGRATION: 'legacy_migration.start_migration',
    SKIP_MIGRATION: 'legacy_migration.skip_migration',
    CONFIRM_SKIP: 'legacy_migration.confirm_skip',
    MIGRATION_COMPLETE: 'legacy_migration.complete',
    MIGRATION_FAILED: 'legacy_migration.failed'
  }
};

export const ENDPOINTS = {
  USER: {
    LOGIN: `/user/${serviceName}/login?group=lacasae`,
    REGISTER: `/user/${serviceName}/register?group=lacasae`,
    UPDATE: `/user/${serviceName}/update?group=lacasae`,
    REFRESH_DATA: `/user/${serviceName}/{userId}?group=lacasae`,
  }
};

export const AUTH = {
  SERVICE_NAME: serviceName
};
